import React, { Component } from 'react';
import axios from 'axios';
import { ROOT_URL, TOKEN } from '../../config';

export default class Philosophie extends Component {
  state = {
    data: '',
    loading: true,
  }

  componentDidMount() {
    axios.get(`${ROOT_URL}/cockpit-master/api/collections/get/Philosophie?token=${TOKEN}`, {
    method: 'GET',
    authorization: 'basic',
    headers: { 'Content-Type': 'application/json', /*'Access-Control-Allow-Origin': '*'*/ },
  })
    .then(res => this.setState({
      data: res.data,
      loading: false
    }))
  }

  renderList = (list) => {
    return(
      <ul>
        <li>{list.listenpunkt1}</li>
        <li>{list.listenpunkt2}</li>
        <li>{list.listenpunkt3}</li>
        <li>{list.listenpunkt4}</li>
        <li>{list.listenpunkt5}</li>
        <li>{list.listenpunkt6}</li>
        <li>{list.listenpunkt7}</li>
      </ul>
    );
  }

  renderHelper = () => {
    const { entries } = this.state.data;
    return (
      entries.map((entrie, i) => {
        if(entrie.id === i) {

          return (
            <div key={entrie.id} className="col-6 column">
              <div className="container simple-card">
                <h2>{entrie.titel}</h2>
                <p>{entrie.text}</p>
                {this.renderList(entrie)}
              </div>
            </div>
          );
        }
      })
    );
  }

  render() {
    if(this.state.loading) {
      return (<div className="fullScreen container"></div>);
    } else {
      return(
        <div className="container fullScreen">
          <h1 className="effect container">Philosophie und Geschichte</h1>
          <div className="row col-12 pdt nop mt card">
            {this.renderHelper()}
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/philosophy.js